import {React} from "react";
import   "../pages/styles.css";

import TextImage from "../Common/TextImage";
import ImageText from "../Common/ImageText"
import  Bussey from "../images/AboutUs/Bussey.png"
import rotramel from "../images/AboutUs/Mario n Merlyn 8.jpg"
import lewis from "../images/AboutUs/susan_tom_lewis.jpeg"


const AboutUs = () => {

     return (
<div style={{background:"#eceff3f6"}}>
      <h1 className={`boldFancyHeadFontCenter`} >
          What is the Kermis Club?
      </h1>
      
<div><br></br><br></br><br></br></div>
      
      <div className={`whiteFancyHeadFontCenter`}>Who We Are</div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        
        <TextImage 
          selImage={lewis}
          myText="We are a group of people who come together 3 times a year to 'dress to the nines', 
            whirl the dancefloor, enjoy a fine meal and| socialize with others who enjoy these same things.|
            Our elegant dinner dances provide a platform for building relations and strengthening social
            connections that nurture long lived friendships.  "
            />
      </div>

      <div className={`whiteFancyHeadFontCenter`}>What We Do</div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={rotramel}
          myText="The members of Kermis come from all walks of life but all have at least 3 things in common:||
          The love of ballroom dancing.  We have professional dancers, competitive dancers, dance instructors and 
          social dancers. ||
          The love of fine dining.  We hold our dances as catered events at DFW's finest country clubs for the elegant
          environment and the fantastic chefs.||
          The love of `puttin' on the ritz`.  We are a formal club and we love to show it.  Fine tuxedoes, fancy dresses and beautiful soirees.||
          We come together to socialize and share in our commonalities and relish in our differences."
            />
      </div> 

       <div className={`whiteFancyHeadFontCenter`}>How We Started </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <TextImage 
          selImage={Bussey}
          myText="In 1958 a group of people decided that they had common interests in ballroom dancing and fine dining.|
          They got together and formed the Kermis Club for socializing.|
          It seems fitting that the first president of Kermis Club (Charles L Rounsaville) |was also the president 
          of an organization now known as DallasHR, |showing that even back then the Kermis members valued the social connection
          |and relations with others to be a beneficial positive experience."
            />
      </div>


    </div>
  )
};
   
export default AboutUs;